(() => {
  const once = (root, selector) => root.querySelector(selector);
  const cardScopeSelector = '.product-card, .resource-card, .collection-card, .predictive-search-results__card';

  const injectStabilityStyles = () => {
    if (document.getElementById('sl-next-stability-styles')) return;

    const style = document.createElement('style');
    style.id = 'sl-next-stability-styles';
    style.textContent = `
      .header-logo {
        background: none !important;
        background-image: none !important;
      }

      .product-card .card-gallery :is(quick-add-component, .quick-add, add-to-cart-component),
      product-card .card-gallery :is(quick-add-component, .quick-add, add-to-cart-component),
      .resource-card .card-gallery :is(quick-add-component, .quick-add, add-to-cart-component) {
        position: absolute !important;
        right: 12px !important;
        bottom: 12px !important;
        left: auto !important;
        top: auto !important;
        z-index: 5 !important;
        display: inline-flex !important;
        align-items: center !important;
        justify-content: flex-end !important;
        width: auto !important;
        min-width: 0 !important;
        max-width: calc(100% - 24px) !important;
        min-height: 0 !important;
        padding: 0 !important;
        margin: 0 !important;
        border: 0 !important;
        background: transparent !important;
        box-shadow: none !important;
        color: #111 !important;
      }

      .product-card .card-gallery :is(quick-add-component, .quick-add, add-to-cart-component)::before,
      .product-card .card-gallery :is(quick-add-component, .quick-add, add-to-cart-component)::after,
      product-card .card-gallery :is(quick-add-component, .quick-add, add-to-cart-component)::before,
      product-card .card-gallery :is(quick-add-component, .quick-add, add-to-cart-component)::after {
        content: none !important;
        display: none !important;
      }

      .product-card .card-gallery :is(.quick-add__button, .add-to-cart-button, button),
      product-card .card-gallery :is(.quick-add__button, .add-to-cart-button, button),
      .resource-card .card-gallery :is(.quick-add__button, .add-to-cart-button, button) {
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        gap: 7px !important;
        width: auto !important;
        min-width: 0 !important;
        max-width: 100% !important;
        min-height: 40px !important;
        height: 40px !important;
        padding: 0 14px !important;
        border: 1px solid rgba(17, 17, 17, .12) !important;
        border-radius: 999px !important;
        background: rgba(247, 247, 245, .94) !important;
        color: #111 !important;
        box-shadow: 0 10px 24px rgba(0, 0, 0, .16) !important;
        backdrop-filter: blur(14px) saturate(160%) !important;
        -webkit-backdrop-filter: blur(14px) saturate(160%) !important;
        font-size: 13px !important;
        font-weight: 800 !important;
        line-height: 1 !important;
        letter-spacing: 0 !important;
        text-transform: none !important;
        opacity: 1 !important;
        visibility: visible !important;
      }

      .product-card .card-gallery :is(.quick-add__button, .add-to-cart-button, button) *,
      product-card .card-gallery :is(.quick-add__button, .add-to-cart-button, button) *,
      .resource-card .card-gallery :is(.quick-add__button, .add-to-cart-button, button) * {
        color: #111 !important;
        fill: currentColor !important;
        stroke: currentColor !important;
        opacity: 1 !important;
      }

      .product-card .card-gallery :is(.quick-add__button, .add-to-cart-button, button):hover,
      product-card .card-gallery :is(.quick-add__button, .add-to-cart-button, button):hover,
      .resource-card .card-gallery :is(.quick-add__button, .add-to-cart-button, button):hover {
        transform: translateY(-1px) !important;
        background: #d7ff1f !important;
        border-color: rgba(17, 17, 17, .2) !important;
        box-shadow: 0 12px 28px rgba(0, 0, 0, .2) !important;
      }

      .product-card .card-gallery :is(.quick-add__button, .add-to-cart-button, button):focus-visible,
      product-card .card-gallery :is(.quick-add__button, .add-to-cart-button, button):focus-visible,
      .resource-card .card-gallery :is(.quick-add__button, .add-to-cart-button, button):focus-visible {
        outline: 3px solid #d7ff1f !important;
        outline-offset: 3px !important;
      }

      .product-card .card-gallery :is(.add-to-cart-icon, .svg-wrapper),
      product-card .card-gallery :is(.add-to-cart-icon, .svg-wrapper),
      .resource-card .card-gallery :is(.add-to-cart-icon, .svg-wrapper) {
        width: 18px !important;
        height: 18px !important;
        flex: 0 0 18px !important;
      }

      body:has(.cart-page--empty) :is(shopify-accelerated-checkout-cart, shopify-accelerated-checkout, shop-pay-wallet-button, shop-pay-button, shop-pay-login-button, .shopify-cleanslate, [data-shopify='payment-button'], [class*='shop-pay'], [id*='shop-pay']) {
        display: none !important;
        width: 0 !important;
        height: 0 !important;
        min-height: 0 !important;
        max-height: 0 !important;
        padding: 0 !important;
        margin: 0 !important;
        overflow: hidden !important;
      }

      body:has(.cart-page--empty) .cart-page--empty {
        margin-top: 24px !important;
      }

      @media screen and (max-width: 749px) {
        .product-card .card-gallery :is(quick-add-component, .quick-add, add-to-cart-component),
        product-card .card-gallery :is(quick-add-component, .quick-add, add-to-cart-component),
        .resource-card .card-gallery :is(quick-add-component, .quick-add, add-to-cart-component) {
          right: 9px !important;
          bottom: 9px !important;
          max-width: calc(100% - 18px) !important;
        }

        .product-card .card-gallery :is(.quick-add__button, .add-to-cart-button, button),
        product-card .card-gallery :is(.quick-add__button, .add-to-cart-button, button),
        .resource-card .card-gallery :is(.quick-add__button, .add-to-cart-button, button) {
          min-height: 36px !important;
          height: 36px !important;
          padding: 0 11px !important;
          gap: 5px !important;
          font-size: 12px !important;
          box-shadow: 0 8px 18px rgba(0, 0, 0, .16) !important;
        }

        .product-card .card-gallery :is(.add-to-cart-icon, .svg-wrapper),
        product-card .card-gallery :is(.add-to-cart-icon, .svg-wrapper),
        .resource-card .card-gallery :is(.add-to-cart-icon, .svg-wrapper) {
          width: 16px !important;
          height: 16px !important;
          flex-basis: 16px !important;
        }
      }
    `;
    document.head.appendChild(style);
  };

  const restoreCollectionCards = () => {
    const snapshots = window.__slProductCardSnapshots;
    if (!snapshots || typeof snapshots.get !== 'function') return;

    document.querySelectorAll('product-card-link[data-product-id]').forEach((node) => {
      if (node.querySelector('product-card, .product-card')) return;
      const productId = node.getAttribute('data-product-id');
      const html = productId ? snapshots.get(productId) : '';
      if (!html) return;
      node.removeAttribute('data-product-transition');
      node.setAttribute('data-sl-restored', 'true');
      node.innerHTML = html;
      node.style.removeProperty('height');
      node.style.removeProperty('width');
    });
  };

  const removeMisplacedProductEnhancements = () => {
    document
      .querySelectorAll(`${cardScopeSelector} .sl-next-pdp-proof, ${cardScopeSelector} .sl-next-atc-note`)
      .forEach((node) => node.remove());
  };

  const isProductTemplate = () => {
    const main = document.getElementById('MainContent');
    const template = main?.dataset?.template || document.body.dataset?.template || '';

    return template.includes('product') || document.body.classList.contains('template-product');
  };

  const enhanceProductPage = () => {
    removeMisplacedProductEnhancements();

    if (!isProductTemplate()) return;

    const productRoot = once(document, '.product-information__grid, .product-details, main[id="MainContent"]') || document;
    const form = once(productRoot, 'product-form-component form[action*="/cart/add"], form[action*="/cart/add"]');
    if (!form || form.closest(cardScopeSelector)) return;

    const details = form.closest('.product-details') || form.closest('product-form-component')?.parentElement;
    if (!details) return;

    if (!once(details, '.sl-next-pdp-proof')) {
      form.insertAdjacentHTML('beforebegin', `
        <div class="sl-next-pdp-proof" aria-label="Kaufvorteile">
          <div class="sl-next-pdp-proof__item"><strong>Sicher bezahlen</strong><span>Verschluesselte Zahlung ueber Shopify Checkout.</span></div>
          <div class="sl-next-pdp-proof__item"><strong>Schnell startklar</strong><span>Ideal fuer Home-Gym, Griffkraft und funktionelles Training.</span></div>
          <div class="sl-next-pdp-proof__item"><strong>Einfach anpassen</strong><span>Menge und Bestellung kannst du im Warenkorb pruefen.</span></div>
        </div>
      `);
    }

    const button = once(form, 'button[type="submit"], button[name="add"]');
    if (button && !button.getAttribute('aria-label')) {
      button.setAttribute('aria-label', 'Produkt in den Warenkorb legen');
    }

    const buttonWrap = button?.closest('.product-form-buttons') || button?.parentElement;
    if (buttonWrap && !buttonWrap.closest(cardScopeSelector) && !once(buttonWrap, '.sl-next-atc-note')) {
      buttonWrap.insertAdjacentHTML('beforeend', '<p class="sl-next-atc-note">Versand, Steuern und Rabatte werden transparent im Warenkorb und Checkout berechnet.</p>');
    }
  };

  const ensureCartHelperPlacement = () => {
    const preferredTarget = once(document, '.cart-items__wrapper') || once(document, '.cart-page__items');
    if (!preferredTarget) return;

    const existing = once(document, '.sl-next-cart-helper');
    if (existing && !preferredTarget.contains(existing)) {
      preferredTarget.appendChild(existing);
      return;
    }

    if (!existing) {
      preferredTarget.insertAdjacentHTML('beforeend', `
        <div class="sl-next-cart-helper">
          <strong>Dein Setup im Ueberblick</strong>
          <p>Pruefe Menge und Auswahl. Der Checkout zeigt dir danach die finalen Versand- und Zahlungsoptionen.</p>
        </div>
      `);
    }
  };

  const enhanceCartPage = () => {
    const emptyCart = once(document, '.cart-page--empty, .cart__empty, [data-cart-empty]');
    if (emptyCart) {
      document.querySelectorAll('.sl-next-cart-helper').forEach((node) => node.remove());
      if (!once(emptyCart, '.sl-next-empty-helper')) {
        emptyCart.insertAdjacentHTML('beforeend', `
          <div class="sl-next-empty-helper">
            <strong>Starte mit deinem Training-Setup</strong>
            <p>Entdecke Bestseller und ergaenze spaeter passendes Zubehoer im Warenkorb.</p>
          </div>
        `);
      }
      return;
    }

    const summary = once(document, '.cart-page__summary, .cart__summary-container');
    if (summary && !once(summary, '.sl-next-checkout-card')) {
      summary.insertAdjacentHTML('afterbegin', `
        <div class="sl-next-checkout-card" aria-label="Checkout Vorteile">
          <div class="sl-next-checkout-card__head"><strong>Bereit fuer den sicheren Checkout</strong><span class="sl-next-checkout-card__badge">Premium Checkout</span></div>
          <ul>
            <li>Sichere Zahlung und verschluesselte Uebertragung.</li>
            <li>Rabatte, Versand und Gesamtsumme bleiben klar sichtbar.</li>
            <li>Du kannst Produkte und Mengen vor dem Kauf jederzeit anpassen.</li>
          </ul>
        </div>
      `);
    }

    const checkoutButton = once(document, '.cart__checkout-button, button[name="checkout"], a[href*="/checkout"]');
    if (checkoutButton && !checkoutButton.getAttribute('aria-label')) {
      checkoutButton.setAttribute('aria-label', 'Sicher zur Kasse gehen');
    }

    ensureCartHelperPlacement();
  };

  const enhance = () => {
    injectStabilityStyles();
    restoreCollectionCards();
    removeMisplacedProductEnhancements();
    enhanceProductPage();
    enhanceCartPage();
  };

  injectStabilityStyles();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhance, { once: true });
  } else {
    enhance();
  }

  [50, 120, 250, 450, 1000, 1800, 3000, 5000].forEach((delay) => window.setTimeout(restoreCollectionCards, delay));
  document.addEventListener('shopify:section:load', enhance);
  document.addEventListener('cart:update', enhance);
  document.addEventListener('cart:refresh', enhance);
  window.addEventListener('pageshow', enhance);
})();
